"use client";

import { Command } from "cmdk";
import { useCommand } from "~/app/[lang]/command/Context";

export function CommandInput({ placeholder }: { placeholder: string }) {
	const { setInputValue, inputValue } = useCommand();

	return (
		<Command.Input
			autoFocus
			placeholder={placeholder}
			value={inputValue}
			onValueChange={(value) => setInputValue(value)}
			className="mb-4 w-full border-shades-medium-light enter:border-shades-medium border-b p-2 focus:outline-none motion-safe:transition-colors"
		/>
	);
}
